export default {
    meta: {
        title: '选址任务历史列表'
    }
};
